import { backendApi } from '../../config'

export type AvailabilityResponse = {
  available: boolean
}

export const checkCustomerEmailAvailability = async (
  email: string
): Promise<AvailabilityResponse> => {
  const response = await backendApi.get<AvailabilityResponse>(
    '/api/customers/availability/email',
    { params: { email } }
  )
  return response.data
}

export const checkCustomerDocumentAvailability = async (
  document: string
): Promise<AvailabilityResponse> => {
  const response = await backendApi.get<AvailabilityResponse>(
    '/api/customers/availability/document',
    { params: { document: document.replace(/\D/g, '') } }
  )
  return response.data
}
